// extracted by mini-css-extract-plugin
export default {"wrapper":"TraceProperties_wrapper__61g3-","line":"TraceProperties_line__qcZUG","input":"TraceProperties_input__ZcMWx"};